import { styled, Typography as UiTypography } from "@l2r-front/l2r-ui"

export const Typography = styled(UiTypography)(({ theme }) => ({
    marginTop: theme.spacing(12),
    textAlign: "center",
}))

export const Header = styled("div")(({ theme }) => ({
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "row",
    width: "100%",
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
}))

export const TextWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
}))